module.exports = __webpack_public_path__ + "src/img/zalando/zdt-ui-2.5bb24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/zdt-ui-2.jpg
// module id = 275
// module chunks = 0